<script setup lang="ts">
import { onMounted } from "vue";
import { useImportAssetStore } from "@/store/import/import_asset_store";
import ImportLocationView from "@/components/import/ImportLocationView.vue";
import ImportSearchInputView from "@/components/import/ImportSearchInputView.vue";
import ImportSearchDetailView from "@/components/import/ImportSearchDetailView.vue";

const store = useImportAssetStore();

onMounted((): void => {
  store.setInitialState();
});
</script>

<template>
  <div class="search-card">
    <!-- SearchLocationView -->
    <ImportLocationView />
    <!-- Search input field start -->
    <ImportSearchInputView />
  </div>
  <div class="margin-30px"></div>
  <ImportSearchDetailView />
</template>
